<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-16 13:41:09
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-01-18 11:01:49
--> 
<template>
  <div>
    <v-menu offset-y
            v-model="isShow"
            z-index="10"
            transition="slide-x-transition"
            nudge-top="60"
            :close-on-content-click='false'>
      <template v-slot:activator="{ on, attrs }">
        <div>
          <mrc_ess_input v-bind="attrs"
                         v-on="on"
                         :background-color="readonly?'':'#f5f5f5'"
                         :error-messages='errMsg'
                         :label="label || $t('label_Email_message')+'*'"
                         :readonly='true'
                         :value="defaultemailsubject.content"
                         append-icon="mdi-longitude">
          </mrc_ess_input>
        </div>
      </template>
      <v-card class="bigbox">
        <v-form ref="fieldForm">
          <v-card-text>
            <v-list-item v-for="(item, index) in childrenpurport"
                         class="mb-0 pa-0"
                         :key="index">
              <mrc_ess_input :label="$t(returnLabel(item.language_code))+'*'"
                             :rules='rules'
                             class="my-0 py-0"
                             @blur="handleinputBlur"
                             :readonly='readonly'
                             v-model="item.content">
              </mrc_ess_input>
              <propertyDialog :readonly='!readonly'
                              class="mt-n1"
                              :function_uuid='function_uuid'
                              sysStatus
                              @getsyslist='getsyslist($event,index)'
                              @getpropertylist='getpropertylist($event,index)'></propertyDialog>
            </v-list-item>
            <mrc_ess_submitBtn v-if="!readonly"
                               @cancel="cancel"
                               backgroundColor="#FFFFFF"
                               class="submitBtn"
                               style="height: auto;justify-content: flex-end;"
                               @success="success">
            </mrc_ess_submitBtn>
            <!-- <div class="btnbox"
                 v-show="!readonly">
              <mrc_ess_submitBtn @cancel='cancel'
                                 @success='success'
                                 cancelText='cancel'
                                 successText='OK'>
              </mrc_ess_submitBtn>
            </div> -->
          </v-card-text>
        </v-form>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import propertyDialog from './propertyDialog'
export default {
  components: {
    propertyDialog
  },
  props: {
    errMsg: {
    },
    label: {
      type: String
    },
    purport: {
      type: Array,
      default: () => []
    },
    // defaultemailsubject: {
    //   type: String,
    //   default: '请设置内容'
    // },
    readonly: {
      type: Boolean,
      default: false
    },
    function_uuid: {
      type: String
    },
  },
  model: {
    prop: 'purport',
    event: 'purportChange'
  },
  data () {
    return {
      rules: [
        value => !!value || 'Required.',
      ],
      isShow: false,
      childrenpurport: [],
      blurIndex: null
    };
  },
  computed: {
    defaultemailsubject () {
      let obj = {
        "language_code": this.$store.state.lang,    //国际化代码
        "content_type": "1",    //国际化字段(1:邮件主题  2:邮件内容)
        "content": ''
      }
      this.purport.map(item => {
        if (item.language_code.toLowerCase() == this.$store.state.lang.toLowerCase()) {
          obj = {
            "language_code": item.value,    //国际化代码
            "content_type": "1",    //国际化字段(1:邮件主题  2:邮件内容)
            "content": item.content
          }
        }
      })
      return obj
    }
  },
  created () { },
  watch: {
    isShow (val) {
      if (val) {
        if (Array.isArray(this.purport) && this.purport.length <= 0) {
          if (this.$store.state.currentCompanyLanguage && Array.isArray(this.$store.state.currentCompanyLanguage) && !this.$store.state.currentCompanyLanguage.length > 0) return
          let arr = []
          this.$store.state.currentCompanyLanguage.map(item => {
            arr.push({
              "language_code": item.value,    //国际化代码
              "content_type": "1",    //国际化字段(1:邮件主题  2:邮件内容)
              "content": ''
            })
          })
          this.childrenpurport = this.$clone(arr)
        }
        else {
          this.$set(this, 'childrenpurport', this.$clone(this.purport))
        }
      }
    },
    purport: {
      handler (v) {
        this.childrenpurport = this.$clone(v)
      }, deep: true
    }
  },
  mounted () {
    if (this.$store.state.uuid) {
      this.childrenpurport = this.$clone(this.purport)
    }
    else {
      if (this.$store.state.currentCompanyLanguage && !this.$store.state.currentCompanyLanguage.length > 0) return
      let arr = []
      this.$store.state.currentCompanyLanguage.map(item => {
        arr.push({
          "language_code": item.value,    //国际化代码
          "content_type": "1",    //国际化字段(1:邮件主题  2:邮件内容)
          "content": ''
        })
      })
      this.childrenpurport = this.$clone(arr)
    }
  },

  methods: {
    success () {
      const submit = this.$refs.fieldForm.validate()
      if (!submit) return
      this.isShow = false
      this.$emit('purportChange', this.$clone(this.childrenpurport))
    },
    cancel () {
      this.isShow = false
    },
    getsyslist (v, index) {
      v.map(item1 => {
        this.childrenpurport[index].content ? this.childrenpurport[index].content = this.childrenpurport[index].content.slice(0, this.blurIndex) + item1.property + this.childrenpurport[index].content.slice(this.blurIndex) : this.childrenpurport[index].content = item1.property
      })
    },
    getpropertylist (v, index) {
      v.map(item1 => {
        this.childrenpurport[index].content ? this.childrenpurport[index].content = this.childrenpurport[index].content.slice(0, this.blurIndex) + item1.property + this.childrenpurport[index].content.slice(this.blurIndex) : this.childrenpurport[index].content = item1.property
      })
    },
    handleinputBlur (e) {
      this.blurIndex = e.srcElement.selectionStart
    },
    returnLabel (val) {
      if (this.$store.state.currentCompanyLanguage && !this.$store.state.currentCompanyLanguage.length > 0) return
      let str = null
      this.$store.state.currentCompanyLanguage.forEach(item => {
        if (val.toLowerCase() == item.value.toLowerCase()) {
          str = item.text
        }
      })
      return str
    },
  },
  validations: {

  }
};
</script>

<style scoped>
.submitBtn /deep/ .cencelBtn {
  margin-right: 0;
}
.bigbox {
  padding: 0;
}
/* .btnbox /deep/ .btnGroup {
  justify-content: flex-end;
  flex-direction: end;
  padding-right: 5px;
  background-color: white !important;
} */
.bigbox /deep/ .v-list-item {
  display: block;
  margin-bottom: 15px;
}
.bigbox /deep/ .v-.v-messages {
  min-height: 0px;
}
</style>
